<template>
	<div class="sales-input">
		<div class="bg-warning-400 text-white rounded position-relative">
			<div class="p-3">
                <small>Vị trí hiện tại</small>
				<h1 class="mb-1">{{ currentUser?.account_type?.name }} {{ currentUser?.profile?.business_level?.name  ?? '' }} </h1>
                <small v-if="is_ctv" class="m-0 l-h-n mt-1" style="font-size: 18px;">Cộng tác
                    viên</small>
			</div>
			<router-link :to="{ name: 'profile' }" class="small-box-footer">Xem thêm
				<i class="fas fa-arrow-circle-right"></i>
			</router-link>
		</div>
		<div v-if="isShowMonthDash" class="mb-4 d-flex align-items-center justify-content-between mt-2 rounded">
            <div>
                <el-date-picker
                    @change=switchViewAs();
                    v-model="month"
                    type="month"
                    format="yyyy-MM"
                    value-format="yyyy-MM"
                    style="width: 120px; border: none"
                >
                </el-date-picker>
            </div>
            <div>
                <el-button v-if="[1,2,3,4].includes(keyAccount)" :disabled="loading_personal" v-for="option in salesOptions" :key="option.value"
                           :class="{ active_sales_type: is_personal === option.value }" size="mini" :style="option.style || ''"
                           @click="is_personal = option.value; switchViewAs(option.value)">
                    <i :class="loading_personal ? 'el-icon-loading' : ''"></i> {{ option.label }}
                </el-button>
            </div>

		</div>
		<div class="p-3 my-4 border-0">
			<el-skeleton v-if="loadingPriority" :rows="3" animated />
			<div v-else>
				<p class="chart-title">Doanh số thực tế {{ isBOD ? 'cả công ty' : ''}}:</p>
				<h3 class="chart-amount">{{ sales.real_amount | formatVND }}</h3>
<!--				<p class="chart-sub my-2" style="font-size: 18px;">Doanh số dự kiến: <span class="font-weight-bold">{{ sales.expected_amount | formatVND }}</span> </p>-->
			</div>
		</div>
	</div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import { mapGetters, mapState } from "vuex";
import {DASHBOARD_SALES} from "../../../../core/services/store/dashboard.module";
import {USER_DASHBOARD} from "../../../../core/services/store/profile.module";

export default {
	name: "SalesInput",
	components: {
		VueApexCharts
	},
	computed: {
		...mapState({
			errors: state => state.auth.errors
		}),
		...mapGetters(['currentUser', 'keyAccount', 'targetPersonal',
            'targetTeam', 'isShowMonthDash', 'isBOD', 'isActiveSale'
        ])
	},
	data() {
		return {
			loading_personal: false,
            loadingPriority: false,
            loadingDash: false,
			is_personal: true,
            month: this.$moment().format('YYYY-MM'),
            sales: {
                import_amount: 0,
                real_amount: 0
            },
            salesPersonal: {
                target: 0,
                achieved: 0,
                needMore: 0
            },
            seriesSalesPersonal: [],
			chartOptions: {
				colors: ['#472F92', '#FDB913'],
				labels: ['Đã đạt', 'Cần thêm'],
				chart: {
					type: 'donut',
					height: 200
				},
				plotOptions: {}
			},
			salesOptions: [
				{ label: "Cá nhân", value: true },
				{ label: "Đội", value: false, style: "width: 80px" },
			],
            is_ctv: false
		};
	},

	methods: {
        switchViewAs() {
            this.$store.dispatch(DASHBOARD_SALES, {
                view_as : this.is_personal ? 2 : 1,
                start_date : this.month,
            }).then(res => {
                this.sales = res;
                this.loadingPriority = false;
                this.loadingDash = false;
            })
        }
	},
	mounted() {
        this.is_ctv = this.currentUser?.profile?.is_collaborators ? true : false;
        this.switchViewAs();
	},
};
</script>

<style scoped>
.chart-title {
	font-weight: 600;
	font-size: 24px;
	line-height: 100%;
	letter-spacing: 0px;
	vertical-align: middle;
	color: rgba(0, 0, 0, 1);
}

.chart-amount {
	font-weight: 700;
	font-size: 40px;
	line-height: 100%;
	letter-spacing: 0px;
	vertical-align: middle;
	color: rgba(0, 0, 0, 1);
}

.active_sales_type {
	background-color: #064e3b !important;
	color: #fff !important;
}
.skeleton-graph {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    margin: 15px 0;
}
.guide{
    display: flex;
    flex-direction: column;
    margin: 0 15px;
    align-items: center;
}
.guide div{
    margin: 5px 0;
}
</style>
